/* eslint-disable */
import saveStoreDraft from "../../utils/saveStoreDraft";
import useStoreFormDraft from "../../hooks/useStoreFormDraft";
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import Sidebar from "../../components/sidebar/Sidebar2";
import Navbar from "../../components/navbar/Navbar2";
import Footer from "../../components/footer/Footer";
import Image from "react-bootstrap/Image";
import Modal from "react-modal";
import { doc, setDoc } from "firebase/firestore";
import { db } from "../../firebase";
import { fetchDate } from "../../../src/utils/globleFunc";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import ServiceDetails from "../../components/ServiceDetails";
import ServiceActivation from "../../components/ServiceActivation";
import ActivationWeinsight from "../../components/services/Activation/ActivationWeinsight";
import ActivationFoorCallRequest from "../../components/services/Activation/ActivationFoorCallRequest";
import { CheckCircleIcon, XCircleIcon } from "@heroicons/react/24/solid";
import FoorchatConnection from "../../components/chatbot/uiEffect";
import { useTranslation } from "react-i18next";
import { DHD_PLAN_NAME } from "../../components/DhdCurrentPlanBanner";

const Settings = ({ size, className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size || 24}
    height={size || 24}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <circle cx="12" cy="12" r="3"></circle>
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
  </svg>
);

function Services() {
  const { t } = useTranslation();
  const MySwal = withReactContent(Swal);
  const [loading, setLoading] = useState(false);
  const [showSideBar, setShowSideBar] = useState(true);
  const [selectedService, setSelectedService] = useState(null);
  const [selectedWeInsight, setSelectedWeInsight] = useState(false);
  const [selectedFoorCall, setSelectedFoorCall] = useState(false);
  const [activeFilter, setActiveFilter] = useState("detailsService");
  const [isButtonVisible, setIsButtonVisible] = useState(true);
  const [currentDate, setCurrentDate] = useState("");
  const [isOpen, setIsOpen] = useState({});
  const digitalStore = useSelector((state) => state.digitalStoreReducer);

  const store = useSelector((state) => state.StoreReducer);
  const [data, setData] = useStoreFormDraft(store);
  const account = useSelector((state) => state.AccountReducer);
  const isDhdUser =
    account?.subscription?.plan === DHD_PLAN_NAME &&
    account?.subscription?.dhdPartnershipActive === true;

  const handleOpenModal = (service) => {
    setSelectedService(service);
  };

  const handleCloseModal = () => {
    setSelectedService(null);
  };

  const handleOpenWeInsightModal = () => {
    setSelectedWeInsight(true);
  };

  const handleCloseWeInsightModal = () => {
    setSelectedWeInsight(false);
  };

  const handleOpenFoorCallModal = () => {
    setSelectedFoorCall(true);
  };

  const handleCloseFoorCallModal = () => {
    setSelectedFoorCall(false);
  };

  const toggleDropdown = (id) => {
    setIsOpen((prev) => {
      const newState = {};
      Object.keys(prev).forEach((key) => {
        newState[key] = false;
      });
      newState[id] = !prev[id];
      return newState;
    });
  };

  const services = [
    {
      id: "googlesheetV3",
      name: "SheetPro",
      key: "googleSheetId",
      icon: "https://cdn-icons-png.flaticon.com/512/2913/2913989.png",
      link: "/settings/services/googleSheetV3",
      rating: 4.9,
      reviews: 814,
      price: "مجاني",
      description: t("ui.sheetServiceSummary"),
    },
    {
      id: "facebookpixel",
      key: "facebookPixel",
      name: t("services.services.facebook_pixel.name"),
      icon: "https://cdn-icons-png.flaticon.com/128/733/733547.png",
      link: "/settings/services/facebookPixel",
      reviews: 1200,
      rating: 4.5,
      price: t("services.services.facebook_pixel.price"),
      description: t("services.services.facebook_pixel.description"),
    },
    {
      id: "facebookcatalog",
      key: "facebookCatalogFeed",
      name: t("services.services.facebook_catalog.name"),
      icon: "https://cdn-icons-png.flaticon.com/128/5968/5968764.png",
      link: "/settings/services/facebookCatalog",
      reviews: 980,
      rating: 4.6,
      price: t("services.services.facebook_catalog.price"),
      description: t("services.services.facebook_catalog.description"),
    },
    {
      id: "tiktokpixel",
      key: "tiktokPixel",
      name: t("services.services.tiktok_pixel.name"),
      icon: "https://cdn-icons-png.flaticon.com/128/15713/15713399.png",
      link: "/settings/services/tiktokPixel",
      rating: 5,
      reviews: 50,
      price: t("services.services.tiktok_pixel.price"),
      description: t("services.services.tiktok_pixel.description"),
    },
    // {
    //   id: "snapchatpixel",
    //   key: "snapchatPixel",
    //   name: t("services.services.snapchat_pixel.name"),
    //   icon: "/snaplogo.png",
    //   link: "/settings/services/snapchatPixel",
    //   rating: 4.9,
    //   reviews: 35,
    //   price: t("services.services.snapchat_pixel.price"),
    //   description: t("services.services.snapchat_pixel.description"),
    //   theme: 2,
    // },
    // {
    //   id: "googletagmanager",
    //   key: "googleTagManager",
    //   name: t("services.services.google_tag_manager.name"),
    //   icon: "/gtm.png",
    //   link: "/settings/services/googleTagManager",
    //   rating: 4.8,
    //   reviews: 95,
    //   price: t("services.services.google_tag_manager.price"),
    //   description: t("services.services.google_tag_manager.description"),
    //   theme: 2,
    // },
    // {
    //   id: "microsoftclarity",
    //   key: "microsoftClarity",
    //   name: t("services.services.microsoft_clarity.name"),
    //   icon: "/clarity.jpg",
    //   link: "/settings/services/microsoftClarity",
    //   rating: 4.7,
    //   reviews: 55,
    //   price: t("services.services.microsoft_clarity.price"),
    //   description: t("services.services.microsoft_clarity.description"),
    //   theme: 2,
    // },
    {
      id: "facebookapi",
      key: "Facebookapi",
      name: t("services.services.facebook_api_conversions.name"),
      icon: "https://cdn-icons-png.flaticon.com/128/6033/6033716.png",
      link: "/settings/services/facebookapi",
      rating: 4.1,
      reviews: 460,
      price: t("services.services.facebook_api_conversions.price"),
      description: t("services.services.facebook_api_conversions.description"),
      theme: 2,
    },
    {
      id: "telegram",
      key: "Idtelegram",
      name: t("services.services.telegram_notification.name"),
      icon: "https://cdn-icons-png.flaticon.com/128/2111/2111644.png",
      link: "/settings/services/telegram",
      rating: 5,
      reviews: 720,
      price: t("services.services.telegram_notification.price"),
      description: t("services.services.telegram_notification.description"),
    },
    {
      id: "facebookDomain",
      key: "facebookDomain",
      name: t("services.services.facebook_domain.name"),
      icon: "https://cdn-icons-png.flaticon.com/512/2282/2282226.png",
      link: "/settings/services/facebookDomain",
      rating: 4.8,
      reviews: 900,
      price: t("services.services.facebook_domain.price"),
      description: t("services.services.facebook_domain.description"),
    },
    // {
    //   id: "pagespeak",
    //   key: "speakpageP",
    //   name: t("services.services.pagespeak.name"),
    //   icon: "/speaker.png",
    //   link: "/settings/services/pagespeak",
    //   rating: 4.3,
    //   reviews: 92,
    //   price: t("services.services.pagespeak.price"),
    //   description: t("services.services.pagespeak.description"),
    // },
    {
      id: "abandonedOrders",
      key: "orderabondant",
      name: t("services.services.abandoned_orders.name"),
      icon: "https://cdn-icons-png.flaticon.com/512/13466/13466888.png",
      link: "/settings/services/abondonedorders",
      rating: 5,
      reviews: 2500,
      price: t("services.services.abandoned_orders.price"),
      description: t("services.services.abandoned_orders.description"),
    },
    {
      id: "upsell",
      key: "Upsell",
      name: t("services.services.upsell.name"),
      icon: "/upsell.png",
      link: "/settings/services/upsell",
      rating: 4.7,
      reviews: 40,
      price: t("services.services.upsell.price"),
      description: t("services.services.upsell.description"),
    },
    {
      id: "confirmchat",
      key: "confirmChat",
      name: t("services.services.confirmchat.name"),
      icon: "https://cdn-icons-png.flaticon.com/128/3655/3655447.png",
      link: "/settings/services/confirmchat",
      rating: 5,
      reviews: 67,
      price: t("services.services.confirmchat.price"),
      description: t("services.services.confirmchat.description"),
    },
    {
      id: "keepsafe",
      key: "security",
      name: t("services.services.keepsafe.name"),
      icon: "/keepsafe.png",
      link: "/settings/services",
      rating: 5,
      reviews: 78,
      price: t("services.services.keepsafe.price"),
      description: t("services.services.keepsafe.description"),
    },
    // {
    //   id: "foorcall",
    //   key: "foorcall",
    //   name: "Foorcall",
    //   icon: "/loggof.png",
    //   link: "/settings/services/foorcall",
    //   rating: 4.9,
    //   reviews: 213,
    //   price: "مجاني",
    //   description: t("services.services.foorcall.description"),
    // },
    {
      id: "ecomanger",
      key: "ecomangerActive",
      name: t("services.services.ecomanger.name"),
      icon: "/ecomanger.png",
      link: "/settings/services/ecomanager",
      rating: 5,
      reviews: 30,
      price: "مجاني",
      description: t("services.services.ecomanger.description"),
    },
    {
      id: "trackship",
      key: "nametrack",
      name: t("services.services.trackship.name"),
      icon: "/trackship.png",
      link: "/settings/services/trackship",
      rating: 5,
      reviews: 81,
      price: "مجاني",
      description: t("services.services.trackship.description"),
    },
    {
      id: "tiktokaconversion",
      key: "TikTokAccessToken",
      name: t("services.services.tiktok_api_conversions.name"),
      icon: "/tiktokconversion.png",
      link: "/settings/services/tiktokconversion",
      rating: 4.8,
      reviews: 10,
      price: t("services.services.tiktok_api_conversions.price"),
      description: t("services.services.tiktok_api_conversions.description"),
      theme: 2,
    },
    {
      id: "weinsight",
      key: "accessTokenFacebookAds",
      name: t("services.services.we_insight.name"),
      icon: "/weinsight.png",
      link: "/settings/services/weinsight",
      rating: 5,
      reviews: 20,
      price: t("services.services.we_insight.price"),
      description: t("services.services.we_insight.description"),
    },
    {
      id: "cloakingcountries",
      name: t("services.services.cloaking_countries.name"),
      key: "cloakingCountries",
      icon: "https://cdn-icons-png.flaticon.com/512/3898/3898082.png",
      link: "/settings/services/cloakingCountries",
      rating: 4.7,
      reviews: 54,
      price: t("services.services.cloaking_countries.price"),
      description: t("services.services.cloaking_countries.description"),
    },
    {
      id: "imaginaryDetectionApp",
      name: t("services.services.imaginary_detection_app.name"),
      key: "imaginaryDetectionApp",
      icon: "/logoai.png",
      link: "/settings/services/imaginaryDetectionApp",
      rating: 4.9,
      reviews: 20,
      price: t("services.services.imaginary_detection_app.price"),
      description: t("services.services.imaginary_detection_app.description"),
    },
    {
      id: "orderdz",
      name: t("services.services.order_dz.name"),
      key: "orderdzToken",
      icon: "/orderdz.png",
      link: "/settings/services/ordersdz",
      rating: 4.7,
      reviews: 4,
      price: t("services.services.order_dz.price"),
      description: t("services.services.order_dz.description"),
    },
    {
      id: "digitalProducts",
      name: "Digital Products",
      key: "isActiveDigitalProducts",
      icon: "/digitalProducts.png",
      link: "/settings/services/digitalProducts",
      rating: 4.9,
      reviews: 5,
      price: t("services.services.digital_products.price"),
      description: t("services.services.digital_products.description"),
    },
    {
      id: "sawa9ly",
      name: t("services.services.Sawa9ly.name"),
      key: "sawa9lyToken",
      icon: "/sawa9ly.jpg",
      link: "/settings/services/sawa9ly",
      rating: 4.9,
      reviews: 8,
      price: t("services.services.Sawa9ly.price"),
      description: t("services.services.Sawa9ly.description"),
      theme: 2,
    },
    {
      id: "CrossSell",
      name: t("sidebar.crossSell"),
      key: "crossSell",
      icon: "/crossels.webp",
      link: "/settings/services/crosssell",
      rating: 4.9,
      reviews: 8,
      price: t("services.services.crossSell.price"),
      description: t("servicePageDetails.crossSell.title"),
    },
    {
      id: "Vendex",
      name: t("services.services.Vendex.name"),
      key: "VendexActive",
      icon: "/vendex.jpg",
      link: "/settings/services/vandex",
      rating: 4.9,
      reviews: 8,
      price: t("services.services.Vendex.price"),
      description: t("services.services.Vendex.description"),
      theme: 2,
    },
    // {
    //   id: "CashBack",
    //   name: "CashBack",
    //   key: "cashBack",
    //   icon: "/cashBack.png",
    //   link: "/settings/services/cashback",
    //   rating: 4.9,
    //   reviews: 8,
    //   price: t("services.services.CashBack.price"),
    //   description: t("servicePageDetails.cashBack.title"),
    // },
    // {
    //   id: "CountrySelector",
    //   name: "CountrySelector",
    //   key: "countrySelectorEnabled",
    //   icon: "/CountrySelector.jpg",
    //   link: "/settings/services/CountrySelector",
    //   rating: 4.9,
    //   reviews: 8,
    //   price: t("services.services.CountrySelector.price"),
    //   description: t("services.services.CountrySelector.description"),
    // },
    // {
    //   id: "orderMessagesEnabled",
    //   name: "Messages Editor",
    //   key: "orderMessagesEnabled",
    //   icon: "/MessagesEditor.jpg",
    //   link: "/settings/services/MessagesEditor",
    //   rating: 4.9,
    //   reviews: 8,
    //   price: t("services.services.CountrySelector.price"),
    //   description: t("services.services.CountrySelector.description"),
    // },
    // {
    //   id: "foorchat",
    //   name: "FoorChat",
    //   key: "foorchat",
    //   icon: "https://foorweb-backend.sfo3.digitaloceanspaces.com/17531147847271753114781237-2592317.png",
    //   link: "/settings/services/ActivationFoorchat",
    //   rating: 4.9,
    //   reviews: 10,
    //   price: "مدفوع",
    //   description:
    //     "تطبيق مخصص للرد التلقائي على رسائل العملاء في منصات التواصل الاجتماعي وتحويلها مباشرةً إلى طلبات حقيقية في متجرك، مع أدوات ذكية لتحليل الرسائل وتصنيفها، وتنبيهات تلقائية، لتوفير وقتك وزيادة مبيعاتك وتحسين جودة تفاعلك مع العملاء.",
    // },
    // {
    //   id: "googlesheetV2",
    //   name: "Google Sheet Version 2",
    //   key: "googlesheet",
    //   icon: "https://cdn-icons-png.flaticon.com/512/720/720244.png",
    //   link: "/settings/services/googleShit",
    //   rating: 4.9,
    //   reviews: 814,
    //   price: "مجاني",
    //   description:
    //     "أداة قوية لتنظيم بيانات متجرك - تزامن فوري للطلبات والمنتجات مع جداول Google، مما يتيح لك التحليل المتقدم واتخاذ قرارات تجارية أفضل",
    // },
    {
      id: "googlesheet",
      name: t("services.services.google_sheet.name"),
      key: "googleSheet",
      icon: "https://cdn-icons-png.flaticon.com/512/720/720244.png",
      link: "/settings/services/googleSheet",
      rating: 4.9,
      reviews: 814,
      price: t("services.services.google_sheet.price"),
      description: t("services.services.google_sheet.description"),
    },
    // {
    //   id: "foorcall_request",
    //   name: t("services.services.foorcall_request.name"),
    //   key: "foorCallRequestId",
    //   icon: "/loggof.png",
    //   link: "/settings/services/foorcall",
    //   rating: 5,
    //   reviews: 0,
    //   price: t("services.services.foorcall_request.price"),
    //   description: t("services.services.foorcall_request.description"),
    // },
    // {
    //   id: "smartsuivi",
    //   name: t("services.services.smart_suivi.name"),
    //   key: "smartSuiviActive",
    //   icon: "/phone-call.png",
    //   link: "/settings/services/smartsuivi",
    //   rating: 5,
    //   reviews: 0,
    //   price: t("services.services.smart_suivi.price"),
    //   description: t("services.services.smart_suivi.description"),
    // },
    // {
    //   id: "printAgent",
    //   key: "printAgentActive",
    //   name: t("services.services.print_agent.name"),
    //   icon: "/loggof.png",
    //   link: "/settings/services/printAgent",
    //   rating: 5,
    //   reviews: 0,
    //   price: t("services.services.print_agent.price"),
    //   description: t("services.services.print_agent.description"),
    // },
    {
      id: "orderExporting",
      key: "orderExportingEnabled",
      name: t("services.services.order_exporting.name"),
      icon: "/exportlogo.png",
      link: "/settings/services/orderExporting",
      rating: 4.9,
      reviews: 12,
      price: t("services.services.order_exporting.price"),
      description: t("services.services.order_exporting.description"),
    },
  ];

  const activeServicesCount = services.filter(
    (service) =>
      store[service.key] !== null &&
      store[service.key] !== "" &&
      store[service.key] !== false &&
      store[service.key] !== undefined,
  ).length;

  const inactiveServicesCount = services.length - activeServicesCount;

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth <= 1080) {
        setShowSideBar(false);
      } else {
        setShowSideBar(true);
      }
    }

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (Object.values(isOpen).some((val) => val === true)) {
        const dropdownElements = document.querySelectorAll(
          ".dropdown-container",
        );
        let clickedInside = false;

        dropdownElements.forEach((element) => {
          if (element.contains(event.target)) {
            clickedInside = true;
          }
        });

        if (!clickedInside) {
          setIsOpen({});
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  useEffect(() => {
    const fetchAndSetCurrentDate = async () => {
      try {
        const res = await fetchDate();
        setCurrentDate(res);
      } catch (error) {
        console.error(t("services.error_fetching_date"), error);
      }
    };

    fetchAndSetCurrentDate();

    const interval = setInterval(() => fetchAndSetCurrentDate(), 60000);
    return () => clearInterval(interval);
  }, [t]);

  const handleDChangeN = () => {
    setData({ ...data, speakpage: true });
  };

  const handleSubmit = async (e, rowData) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (
        account.subscription?.tokens >= 90 ||
        account.subscription?.endDate?.seconds > currentDate
      ) {
        await saveStoreDraft(doc(db, "store", data.id), store, data);
        await setDoc(doc(db, "account", account.id), {
          ...account,
          subscription: {
            ...account.subscription,
            tokens: account.subscription.tokens - 90,
          },
        });

        Swal.fire({
          icon: "success",
          title: t("services.success_activation"),
          confirmButtonText: t("services.ok"),
          confirmButtonColor: "rgb(141, 93, 167)",
        }).then((result) => {
          if (result.isConfirmed) {
            window.location.href = "/settings/services/pagespeak";
          }
        });

        handleDChangeN();
      } else {
        Swal.fire({
          icon: "error",
          title: t("services.insufficient_balance"),
          text: t("services.insufficient_balance_text"),
          confirmButtonText: t("services.top_up_balance"),
          confirmButtonColor: "rgb(141, 93, 167)",
          showCancelButton: true,
          cancelButtonText: t("services.cancel"),
          cancelButtonColor: "#e87778",
        }).then((result) => {
          if (result.isConfirmed) {
            if ((account.productMode ?? "classic") == "classic") {
              window.location.href = "/plan";
            } else {
              window.location.href = "/digital/plan";
            }
          }
        });
      }
    } catch (error) {
      console.error(t("services.error_during_operation"), error);
      Swal.fire({
        icon: "error",
        title: t("services.error_during_operation"),
        text: error.message,
        confirmButtonText: t("services.ok"),
        confirmButtonColor: "rgb(141, 93, 167)",
      });
    } finally {
      setLoading(false);
    }
  };

  const message = () => {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success mx-2",
        cancelButton: "btn btn-danger mx-2",
      },
      buttonsStyling: false,
    });

    swalWithBootstrapButtons
      .fire({
        title: t("services.contact_for_free_trial"),
        showCancelButton: true,
        confirmButtonText: t("services.yes"),
        cancelButtonText: t("services.no"),
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          window.open("https://m.me/F0orweb", "_blank", "noopener,noreferrer");
        }
      });
  };

  const comingSoon = () => {
    MySwal.fire({
      title: <p>{t("services.coming_soon")}</p>,
      isDismissed: true,
    });
  };

  return (
    <div
      className="container-fluid bg-purple-50 min-h-screen dark:!bg-[#141414]"
      dir={t("services.direction")}
    >
      <div className="row">
        <FoorchatConnection store={store} />

        {showSideBar && (
          <div
            style={{
              width: "250px",
              flexShrink: 0,
              transition: "width 0.6s ease",
              boxShadow: "2px 0 10px rgba(0,0,0,0.05)",
            }}
          >
            <Sidebar
              showSideBar={showSideBar}
              setShowSideBar={setShowSideBar}
            />
          </div>
        )}
        <div
          className="px-3 dark:!bg-[#141414]"
          style={{
            flex: 1,
            backgroundColor: "#fbf8fc",
          }}
        >
          <Navbar showSideBar={showSideBar} setShowSideBar={setShowSideBar} />

          {/* Page Header */}
          <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-4 m-3 border border-[#fbf4ff] dark:!border-[#3c3a3d]">
            <div className="flex flex-wrap items-center justify-between gap-3">
              <div>
                <h2 className="text-xl font-bold text-[#9e68ba] mb-1">
                  {t("services.store_applications")}
                </h2>
                <p className="text-gray-600 dark:!text-gray-400 mb-0">
                  {t("services.store_applications_description", {
                    count: services.length,
                  })}
                </p>
              </div>
            </div>
          </div>

          {/* Stats Cards */}
          <div className="overflow-x-auto pb-4 md:overflow-visible">
            <div className="flex md:grid md:grid-cols-3 lg:grid-cols-6 gap-4 p-3 min-w-max md:min-w-0">
              {/* Active Services Card */}
              <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-4 border border-[#fbf4ff] dark:!border-[#3c3a3d] transition-all hover:shadow-md w-60 md:w-auto flex-shrink-0">
                <div className="flex justify-between items-start mb-4">
                  <div className="rounded-lg overflow-hidden shadow-sm border-2 border-white dark:!border-[#3c3a3d] w-10 h-10 bg-[#faf1ff] dark:!bg-[#2a2a2a] flex items-center justify-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="text-[#9e68ba]"
                    >
                      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                      <polyline points="22 4 12 14.01 9 11.01"></polyline>
                    </svg>
                  </div>
                </div>
                <div className="flex justify-between items-end">
                  <div>
                    <span className="text-sm font-medium text-gray-500 dark:!text-gray-400">
                      {t("services.active_applications")}
                    </span>
                    <div className="flex items-center mt-1">
                      <span className="w-2 h-2 bg-purple-400 rounded-full ml-2"></span>
                      <span className="text-lg font-semibold dark:!text-white">
                        {activeServicesCount}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Inactive Services Card */}
              <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-4 border border-[#fbf4ff] dark:!border-[#3c3a3d] transition-all hover:shadow-md w-60 md:w-auto flex-shrink-0">
                <div className="flex justify-between items-start mb-4">
                  <div className="rounded-lg overflow-hidden shadow-sm border-2 border-white dark:!border-[#3c3a3d] w-10 h-10 bg-[#faf1ff] dark:!bg-[#2a2a2a] flex items-center justify-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="text-[#9e68ba]"
                    >
                      <line x1="18" y1="6" x2="6" y2="18"></line>
                      <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                  </div>
                </div>
                <div className="flex justify-between items-end">
                  <div>
                    <span className="text-sm font-medium text-gray-500 dark:!text-gray-400">
                      {t("services.inactive_applications")}
                    </span>
                    <div className="flex items-center mt-1">
                      <span className="w-2 h-2 bg-purple-500 rounded-full ml-2"></span>
                      <span className="text-lg font-semibold dark:!text-white">
                        {inactiveServicesCount}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Pending Payment Card */}
              <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-4 border border-[#fbf4ff] dark:!border-[#3c3a3d] transition-all hover:shadow-md w-60 md:w-auto flex-shrink-0">
                <div className="flex justify-between items-start mb-4">
                  <div className="rounded-lg overflow-hidden shadow-sm border-2 border-white dark:!border-[#3c3a3d] w-10 h-10 bg-[#faf1ff] dark:!bg-[#2a2a2a] flex items-center justify-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="text-[#9e68ba]"
                    >
                      <circle cx="12" cy="12" r="10"></circle>
                      <line x1="12" y1="8" x2="12" y2="12"></line>
                      <line x1="12" y1="16" x2="12.01" y2="16"></line>
                    </svg>
                  </div>
                </div>
                <div className="flex justify-between items-end">
                  <div>
                    <span className="text-sm font-medium text-gray-500 dark:!text-gray-400">
                      {t("services.pending_payment")}
                    </span>
                    <div className="flex items-center mt-1">
                      <span className="w-2 h-2 bg-purple-400 rounded-full ml-2"></span>
                      <span className="text-lg font-semibold dark:!text-white">
                        0
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Renewal Card */}
              <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-4 border border-[#fbf4ff] dark:!border-[#3c3a3d] transition-all hover:shadow-md w-60 md:w-auto flex-shrink-0">
                <div className="flex justify-between items-start mb-4">
                  <div className="rounded-lg overflow-hidden shadow-sm border-2 border-white dark:!border-[#3c3a3d] w-10 h-10 bg-[#faf1ff] dark:!bg-[#2a2a2a] flex items-center justify-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="text-[#9e68ba]"
                    >
                      <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
                    </svg>
                  </div>
                </div>
                <div className="flex justify-between items-end">
                  <div>
                    <span className="text-sm font-medium text-gray-500 dark:!text-gray-400">
                      {t("services.subscription_renewal")}
                    </span>
                    <div className="flex items-center mt-1">
                      <span className="w-2 h-2 bg-purple-500 rounded-full ml-2"></span>
                      <span className="text-lg font-semibold dark:!text-white">
                        0
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Expiring Soon Card */}
              <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-4 border border-[#fbf4ff] dark:!border-[#3c3a3d] transition-all hover:shadow-md w-60 md:w-auto flex-shrink-0">
                <div className="flex justify-between items-start mb-4">
                  <div className="rounded-lg overflow-hidden shadow-sm border-2 border-white dark:!border-[#3c3a3d] w-10 h-10 bg-[#faf1ff] dark:!bg-[#2a2a2a] flex items-center justify-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="text-[#9e68ba]"
                    >
                      <circle cx="12" cy="12" r="10"></circle>
                      <polyline points="12 6 12 12 16 14"></polyline>
                    </svg>
                  </div>
                </div>
                <div className="flex justify-between items-end">
                  <div>
                    <span className="text-sm font-medium text-gray-500 dark:!text-gray-400">
                      {t("services.subscription_expiring_soon")}
                    </span>
                    <div className="flex items-center mt-1">
                      <span className="w-2 h-2 bg-purple-400 rounded-full ml-2"></span>
                      <span className="text-lg font-semibold dark:!text-white">
                        0
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Deleted Services Card */}
              <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-4 border border-[#fbf4ff] dark:!border-[#3c3a3d] transition-all hover:shadow-md w-60 md:w-auto flex-shrink-0">
                <div className="flex justify-between items-start mb-4">
                  <div className="rounded-lg overflow-hidden shadow-sm border-2 border-white dark:!border-[#3c3a3d] w-10 h-10 bg-[#faf1ff] dark:!bg-[#2a2a2a] flex items-center justify-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      className="text-[#9e68ba]"
                    >
                      <path
                        d="M3 6h18"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <line
                        x1="10"
                        x2="10"
                        y1="11"
                        y2="17"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <line
                        x1="14"
                        x2="14"
                        y1="11"
                        y2="17"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                </div>
                <div className="flex justify-between items-end">
                  <div>
                    <span className="text-sm font-medium text-gray-500 dark:!text-gray-400">
                      {t("services.deleted_applications")}
                    </span>
                    <div className="flex items-center mt-1">
                      <span className="w-2 h-2 bg-purple-500 rounded-full ml-2"></span>
                      <span className="text-lg font-semibold dark:!text-white">
                        0
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Services Grid */}
          <div className="p-3">
            <div className="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 gap-4">
              {services.map((service) => {
                const isGoogleSheetService = [
                  "googlesheet",
                  "googlesheetV2",
                  "googlesheetV3",
                ].includes(service.id);

                const isDisabledByDhd = isDhdUser && isGoogleSheetService;

                return (
                  <div
                    key={service.id}
                    className={`bg-white dark:!bg-[#181819] rounded-xl shadow-sm border border-[#fbf4ff] dark:!border-[#3c3a3d] overflow-hidden transition-all duration-200 relative ${
                      isDisabledByDhd
                        ? "opacity-50 cursor-not-allowed"
                        : "hover:shadow-md"
                    }`}
                    title={
                      isDisabledByDhd
                        ? t("ShipCollectPage.dhd_not_supported")
                        : undefined
                    }
                  >
                    {isDisabledByDhd && (
                      <div
                        className="absolute inset-0 z-10 cursor-not-allowed"
                        title={t("ShipCollectPage.dhd_not_supported")}
                      />
                    )}
                    {/* Service Header */}
                    <div className="p-4 h-[150px]">
                      <div className="flex items-start justify-between">
                        <div className="flex items-start gap-3">
                          <div className="rounded-xl border border-[#fbf4ff] dark:!border-[#3c3a3d] p-2 w-16 h-16 flex items-center justify-center bg-white dark:!bg-[#2a2a2a] shrink-0">
                            <Image
                              src={service.icon}
                              alt={service.name}
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "contain",
                              }}
                            />
                          </div>

                          <div>
                            <h3
                              className="font-bold text-xl text-[#9e68ba] mb-1 cursor-pointer dark:!text-[#b48acb]"
                              onClick={() => {
                                if (isDisabledByDhd) return;
                                if (service.id === "weinsight") {
                                  handleOpenWeInsightModal();
                                } else if (service.id === "foorcall_request") {
                                  handleOpenFoorCallModal();
                                } else {
                                  handleOpenModal(service);
                                }
                              }}
                            >
                              {service.name}
                            </h3>

                            <div className="flex items-center text-sm text-gray-500 dark:!text-gray-400 mb-2">
                              <span className="text-yellow-400 ml-1">⭐</span>
                              <span className="font-semibold text-gray-700 dark:!text-gray-300 mx-1">
                                {service.rating}
                              </span>
                              <span>
                                ({service.reviews} {t("services.reviews")})
                              </span>
                            </div>

                            {service.id === "digitalProducts" ? (
                              digitalStore?.isActiveDigitalProducts ? (
                                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 dark:!bg-green-900 text-green-800 dark:!text-green-300">
                                  <CheckCircleIcon className="w-3.5 h-3.5 ml-1" />
                                  {t("services.activated")}
                                </span>
                              ) : (
                                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 dark:!bg-red-900 text-red-800 dark:!text-red-300">
                                  <XCircleIcon className="w-3.5 h-3.5 ml-1" />
                                  {t("services.not_activated")}
                                </span>
                              )
                            ) : store[service.key] !== null &&
                              store[service.key] !== "" &&
                              store[service.key] !== false &&
                              store[service.key] !== undefined ? (
                              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 dark:!bg-green-900 text-green-800 dark:!text-green-300">
                                <CheckCircleIcon className="w-3.5 h-3.5 ml-1" />
                                {t("services.activated")}
                              </span>
                            ) : (
                              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 dark:!bg-red-900 text-red-800 dark:!text-red-300">
                                <XCircleIcon className="w-3.5 h-3.5 ml-1" />
                                {t("services.not_activated")}
                              </span>
                            )}
                          </div>
                          {service.theme === 2 && (
                            <span
                              className="
                                inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium
                                bg-orange-200 text-orange-900
                                dark:!bg-orange-800 dark:!text-orange-200
                              "
                            >
                              <XCircleIcon className="w-3.5 h-3.5 ml-1" />
                              {t("services.themeTwo")}
                            </span>
                          )}
                        </div>
                      </div>

                      <p className="text-gray-600 dark:!text-gray-400 text-sm mt-3 line-clamp-2">
                        {service.description}
                      </p>
                    </div>

                    {/* Service Footer */}
                    <div className="border-t border-[#fbf4ff] dark:!border-[#3c3a3d] p-4 bg-gradient-to-r from-purple-50 to-white dark:!from-[#2a2a2a] dark:!to-[#181819]">
                      <div className="relative dropdown-container">
                        <button
                          onClick={() => {
                            toggleDropdown(service.id);
                            if (service.id === "weinsight") {
                              handleOpenWeInsightModal();
                            } else if (service.id === "foorcall_request") {
                              handleOpenFoorCallModal();
                            } else {
                              handleOpenModal(service);
                            }
                          }}
                          className="w-full bg-[#9b59bf] hover:bg-[#814a9f] transition-colors text-white py-2 px-4 rounded-lg text-sm font-medium flex items-center justify-center"
                        >
                          <Settings size={16} className="ml-2" />
                          <span>{t("services.service_options")}</span>
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Modal for service details/activation */}
          {selectedService && (
            <Modal
              isOpen={!!selectedService}
              onRequestClose={handleCloseModal}
              className="fixed inset-0 z-[9999999] flex items-center justify-center"
              overlayClassName="fixed inset-0 bg-black bg-opacity-50 z-40"
              contentLabel={`${selectedService.name} ${t("services.details")}`}
              ariaHideApp={false}
              style={{
                overlay: {
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "rgba(0, 0, 0, 0.5)",
                  zIndex: 99999,
                },
                content: {
                  position: "relative",
                  top: "auto",
                  left: "auto",
                  right: "auto",
                  bottom: "auto",
                  border: "none",
                  background: "transparent",
                  overflow: "visible",
                  borderRadius: "0",
                  outline: "none",
                  padding: "0",
                  width: "80%",
                  height: "auto",
                  maxHeight: "90vh",
                  margin: "0 auto",
                },
              }}
            >
              <div
                className="bg-white dark:!bg-[#181819] rounded-xl shadow-xl overflow-hidden w-full"
                dir={t("services.direction")}
              >
                {/* Tab Buttons */}
                <div className="flex border-b border-[#fbf4ff] dark:!border-[#3c3a3d]">
                  <button
                    className={`flex-1 py-3 px-4 text-center font-medium transition-colors ${
                      activeFilter === "detailsService"
                        ? "bg-purple-50 dark:bg-[#522868] dark:text-gray-300 text-[#9e68ba] border-b-2 border-[#9b59bf]"
                        : "text-gray-600 hover:bg-purple-50 dark:text-gray-300 hover:dark:bg-[#6e358c]"
                    }`}
                    onClick={() => setActiveFilter("detailsService")}
                  >
                    {t("services.service_details")}
                  </button>
                  <button
                    className={`flex-1 py-3 px-4 text-center font-medium transition-colors ${
                      activeFilter === "activeService"
                        ? "bg-purple-50 dark:bg-[#522868] dark:text-gray-300 text-[#9e68ba] border-b-2 border-[#9b59bf]"
                        : "text-gray-600 hover:bg-purple-50 dark:text-gray-300 hover:dark:bg-[#6e358c]"
                    }`}
                    onClick={() => setActiveFilter("activeService")}
                  >
                    {t("services.activate_service")}
                  </button>
                </div>

                {/* Service Content */}
                <div className="max-h-[80vh] overflow-y-auto">
                  {activeFilter === "detailsService" && selectedService && (
                    <ServiceDetails service={selectedService} />
                  )}

                  {activeFilter === "activeService" && selectedService && (
                    <ServiceActivation
                      service={selectedService}
                      close={handleCloseModal}
                    />
                  )}
                </div>

                {/* Modal Footer */}
                <div className="border-t border-[#fbf4ff] dark:!border-[#3c3a3d] p-4 bg-gray-50 dark:!bg-[#181919] flex justify-between">
                  <button
                    className="text-gray-600 dark:!text-gray-300 hover:text-gray-900 dark:hover:text-white bg-white dark:!bg-[#181919] border border-gray-300 dark:!border-[#3c3a3d] hover:bg-gray-50 dark:hover:bg-[#222222] font-medium py-2 px-4 rounded-lg transition-colors duration-200 flex items-center gap-2"
                    onClick={handleCloseModal}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                    {t("services.close")}
                  </button>
                </div>
              </div>
            </Modal>
          )}

          {/* Modal for WeInsight */}
          {selectedWeInsight && (
            <Modal
              isOpen={selectedWeInsight}
              onRequestClose={handleCloseWeInsightModal}
              className="fixed inset-0 z-[9999999] flex items-center justify-center"
              overlayClassName="fixed inset-0 bg-black bg-opacity-50 z-40"
              contentLabel={`${t("services.services.we_insight.name")} ${t(
                "services.details",
              )}`}
              ariaHideApp={false}
              style={{
                overlay: {
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "rgba(0, 0, 0, 0.5)",
                  zIndex: 99999,
                },
                content: {
                  position: "relative",
                  top: "auto",
                  left: "auto",
                  right: "auto",
                  bottom: "auto",
                  border: "none",
                  background: "transparent",
                  overflow: "visible",
                  borderRadius: "0",
                  outline: "none",
                  padding: "0",
                  width: "80%",
                  margin: "0 auto",
                },
              }}
            >
              <div
                className="bg-white dark:!bg-[#181819] h-fit rounded-xl shadow-xl overflow-hidden w-full"
                dir={t("services.direction")}
              >
                <div className="p-6">
                  <ActivationWeinsight />
                </div>
                <div className="border-t border-[#fbf4ff] p-4 bg-gray-50 flex justify-end dark:!bg-[#181819] dark:!border-[#3c3a3d]">
                  <button
                    className="text-gray-600 hover:text-gray-900 bg-white dark:!bg-[#181819] dark:!text-gray-300 border border-gray-300 dark:!border-[#3c3a3d] hover:bg-gray-50 font-medium py-2 px-4 rounded-lg transition-colors duration-200 flex items-center gap-2"
                    onClick={handleCloseWeInsightModal}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                    {t("services.close")}
                  </button>
                </div>
              </div>
            </Modal>
          )}

          {/* Modal for FoorCall Request */}
          {selectedFoorCall && (
            <Modal
              isOpen={selectedFoorCall}
              onRequestClose={handleCloseFoorCallModal}
              className="fixed inset-0 z-[9999999] flex items-center justify-center"
              overlayClassName="fixed inset-0 bg-black bg-opacity-50 z-40"
              contentLabel={`${t("services.services.foorcall_request.name")} ${t(
                "services.details",
              )}`}
              ariaHideApp={false}
              style={{
                overlay: {
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "rgba(0, 0, 0, 0.5)",
                  zIndex: 99999,
                },
                content: {
                  position: "relative",
                  top: "auto",
                  left: "auto",
                  right: "auto",
                  bottom: "auto",
                  border: "none",
                  background: "transparent",
                  overflow: "visible",
                  borderRadius: "0",
                  outline: "none",
                  padding: "0",
                  width: "80%",
                  margin: "0 auto",
                },
              }}
            >
              <div
                className="bg-white dark:!bg-[#181819] h-fit rounded-xl shadow-xl overflow-hidden w-full"
                dir={t("services.direction")}
              >
                <div className="p-6">
                  <ActivationFoorCallRequest close={handleCloseFoorCallModal} />
                </div>
                <div className="border-t border-[#fbf4ff] p-4 bg-gray-50 flex justify-end dark:!bg-[#181819] dark:!border-[#3c3a3d]">
                  <button
                    className="text-gray-600 hover:text-gray-900 bg-white dark:!bg-[#181819] dark:!text-gray-300 border border-gray-300 dark:!border-[#3c3a3d] hover:bg-gray-50 font-medium py-2 px-4 rounded-lg transition-colors duration-200 flex items-center gap-2"
                    onClick={handleCloseFoorCallModal}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                    {t("services.close")}
                  </button>
                </div>
              </div>
            </Modal>
          )}

          <Footer />
        </div>
      </div>
    </div>
  );
}

export default Services;
